import { CobaltButton } from '@cae/cobalt-react/components/button';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { CobaltIconFilterOutline } from '@cae/cobalt-react/icons/outline/CobaltIconFilterOutline';
import * as React from 'react';

import { UsersFilterButtonProps } from './UsersFilterButton.types';

const UsersFilterButton = React.memo(
  ({
    isLoading,
    onFiltersOpen,
    disabled = false,
  }: Readonly<UsersFilterButtonProps>): React.ReactElement => {
    const isMobileAndTablet = useMediaQuery(MediaQuery.MobileAndTablet);

    return (
      <CobaltButton
        aria-label="View filter panel"
        variant="ghost"
        disabled={disabled || isLoading}
        data-testid="users-filter-button"
        onClick={onFiltersOpen}
      >
        <CobaltIconFilterOutline />
        {!isMobileAndTablet && <>Filters</>}
      </CobaltButton>
    );
  }
);

UsersFilterButton.displayName = 'UsersFilterButton';

export { UsersFilterButton };
